import api from './axios';

export const getStats = async () => {
  const response = await api.get('/dashboard/stats');
  return response.data;
};

export const getRecentActivity = async () => {
  const response = await api.get('/dashboard/recent-activity');
  return response.data;
};

export const getUpcomingEvents = async () => {
  const response = await api.get('/dashboard/upcoming-events');
  return response.data;
};

export const getQuickStats = async () => {
  const response = await api.get('/dashboard/quick-stats');
  return response.data;
};
